import { useIs17Inch, usePatientOnly } from '../../../../hooks/useBreakPoint';
import '../../../../css/data-grid.css';
import { useSubIcon } from '../../../../hooks/useSubIcon';
import { useDynamicStyle } from '../../../../hooks/useDynamicStyle';

const LogDataGrid = ({ dataHead, dataColumn, dataList, percent }) => {

    // Dynamic Style Hook
    const { fontColor, subTitleBorder, lightBackColor } = useDynamicStyle();

    // icon list
    const { NullIcon } = useSubIcon();

    const is17Inch = useIs17Inch();
    const patientOnly = usePatientOnly();

    return (
        <div className={`data_grid_container min-h-10 ${patientOnly ? 'hp-85 wp-40 pt-6' : 'hp-40'}`}>
            <div className={`flex justify-between mr-1 ${subTitleBorder}`}>
                <strong className={`ml-1 ${fontColor}`}>대상환자 로그정보</strong>
                <span className='total_items mr-1'>전체&nbsp;<strong className={fontColor}>{!dataList ? 0 : dataList.length}</strong>건</span>
            </div>
            <div className='data_list_table'>
                <table>
                    <thead>
                        <tr>
                            {dataHead.map((content, index) => (
                                <th width={percent[index]} key={index}>
                                    {content}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {!dataList || dataList.length === 0 ? (
                            <tr>
                                <td colSpan={dataHead.length} className='empty_box'>
                                    <span className={`data_empty ${lightBackColor}`} style={{padding: '1rem'}}>
                                        {NullIcon}대상환자를 선택해주세요!
                                    </span>
                                </td>
                            </tr>
                        ) : (
                            dataList.map((item, index) => {
                                const gridColor = index % 2 === 0 ? lightBackColor : '';
                                return (
                                    <tr key={index} className={gridColor}>
                                        {dataColumn.map((idx, index) => (
                                            <td key={index} width={percent[index]}>{item[idx]}</td>
                                        ))}
                                    </tr>
                                )
                            })
                        )}
                    </tbody>
                </table>
            </div>
            <hr className='mr-1-1 co_border_gray' />
        </div>
    );
};

export default LogDataGrid;